import * as types from './types';

/**
 * Set User Data
 */
export function setActiveModal(modal) {
  return (dispatch) => {
    /*
        Set User Data
         */
    dispatch({
      type: types.SET_ACTIVE_MODAL,
      payload: modal,
    });
  };
}

